import { Link } from 'react-router-dom';
import { allVideos } from '@/mocks/videos';

export default function LatestSection() {
  const latestVideos = [...allVideos]
    .sort((a, b) => new Date(b.updateDate).getTime() - new Date(a.updateDate).getTime())
    .slice(0, 5);

  return (
    <section className="w-full px-4 md:px-6">
      <div className="flex items-center justify-between mb-5">
        <h2 className="text-lg md:text-xl font-bold font-heading text-foreground-900">
          <i className="ri-timer-flash-line text-primary-500 mr-2"></i>
          最近更新
        </h2>
        <Link
          to="/category/all"
          className="text-sm text-primary-600 hover:text-primary-700 flex items-center gap-1 whitespace-nowrap"
        >
          查看全部 <i className="ri-arrow-right-line"></i>
        </Link>
      </div>

      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-4 md:gap-5">
        {latestVideos.map((video) => (
          <Link
            key={video.id}
            to={`/article/${video.id}`}
            className="group block"
          >
            <div className="relative aspect-video rounded-lg overflow-hidden bg-background-200 mb-2.5">
              <img
                src={video.thumbnail}
                alt={video.title}
                title={`${video.title} - 91在线视频`}
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
              />
              <div className="absolute bottom-2 right-2 bg-black/75 text-white text-xs px-1.5 py-0.5 rounded">
                {video.duration}
              </div>
              <div className="absolute top-2 left-2">
                <span className="bg-accent-500 text-white text-xs px-1.5 py-0.5 rounded">
                  更新
                </span>
              </div>
              <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity">
                <div className="w-10 h-10 bg-primary-500/90 rounded-full flex items-center justify-center">
                  <i className="ri-play-fill text-white text-lg ml-0.5"></i>
                </div>
              </div>
            </div>
            <h3 className="text-sm font-medium text-foreground-800 line-clamp-1 group-hover:text-primary-600 transition-colors">
              {video.title}
            </h3>
            <p className="text-xs text-foreground-500 mt-1">更新于 {video.updateDate}</p>
          </Link>
        ))}
      </div>
    </section>
  );
}